import Vue from "vue";
import Router from "vue-router";
import store from "../assets/js/store";

import taobaoIndex from "@/pages/taobao/index"; //淘宝首页
import taobaoSearch from "@/pages/taobao/search"; //淘宝搜索
import taobaoShare from "@/pages/taobao/share"; //链接分享
import taobaoLinkInto from "@/pages/taobao/linkInto"; //链接转化
import taobaoDetail from "@/pages/taobao/detail"; //商品详情

import jdDetail from "@/pages/jd/detail"; //京东商品详情页
import jdIndex from "@/pages/jd/index"; //京东首页
import jdSearch from "@/pages/jd/search"; //京东搜索
import jdShare from "@/pages/jd/share"; //京东分享

import pddDetail from "@/pages/pdd/detail"; //拼多多商品详情页
import pddIndex from "@/pages/pdd/index"; //拼多多首页
import pddSearch from "@/pages/pdd/search"; //拼多多搜索
import pddShare from "@/pages/pdd/share"; //拼多多分享
import pddLinkInto from "@/pages/pdd/linkInto"; //链接转化

import mtIndex from "@/pages/mt/index"; // 美团首页

import elmIndex from "@/pages/elm/index"; // 饿了么首页

import sunningIndex from "@/pages/sunning/index"; // 苏宁易购首页
import sunningSearch from "@/pages/sunning/search"; // 苏宁易购搜索
import sunningDetail from "@/pages/sunning/detail"; // 苏宁易购搜索
import sunningShare from "@/pages/sunning/share"; // 苏宁易购分享页面
import sunningLinkInto from "@/pages/sunning/linkInto"; // 苏宁易购链接转化


import wphgIndex from "@/pages/wph/index"; // 唯品会首页

import user from "@/pages/mine/user"; //我的
import commission from "@/pages/mine/commission"; //佣金
import help from "@/pages/mine/help"; //新手引导
import invite from "@/pages/mine/invite"; //我的邀请
import inviteRecord from "@/pages/mine/inviteRecord"; //邀请记录
import order from "@/pages/mine/order"; //订单
import set from "@/pages/mine/set"; //设置
import changeName from "@/pages/mine/changeName"; //修改昵称
import withdraw from "@/pages/mine/withdraw"; // 提现
import withdrawRecord from "@/pages/mine/withdrawRecord"; // 提现记录
import alipay from "@/pages/mine/alipay"; // 提现绑定支付宝

import agreement from "@/pages/account/agreement"; // 注册协议
import privacy from "@/pages/account/privacy"; // 隐私政策
import login from "@/pages/account/login"; //登录
import reg from "@/pages/account/reg"; //注册
import editPwd from "@/pages/account/editPwd"; //修改密码

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "taobaoIndex",
      meta: {
        keepAlive: true
      },
      component: taobaoIndex //淘宝
    },
    {
      path: "/taobao/search",
      name: "taobaoSearch",
      meta: {
        keepAlive: true
      },
      component: taobaoSearch //淘宝搜索
    },
    {
      path: "/taobao/share",
      name: "taobaoShare",
      component: taobaoShare //淘宝分享
    },
    {
      path: "/taobao/linkInto",
      name: "taobaoLinkInto",
      component: taobaoLinkInto //淘宝链接转化
    },
    {
      path: "/taobao/detail",
      name: "taobaoDetail",
      component: taobaoDetail //淘宝商品详情
    },
    {
      path: "/jd",
      name: "jdIndex",
      meta: {
        keepAlive: true
      },
      component: jdIndex //京东
    },
    {
      path: "/jd/search",
      name: "jdSearch",
      component: jdSearch //京东搜索
    },
    {
      path: "/jd/detail",
      name: "jdDetail",
      component: jdDetail //京东商品详情页
    },
    {
      path: "/jd/share",
      name: "jdShare",
      component: jdShare //京东分享链接
    },
    {
      path: "/pdd/detail",
      name: "pddDetail",
      component: pddDetail //拼多多详情页面
    },
    {
      path: "/pdd",
      name: "pddIndex",
      meta: {
        keepAlive: true
      },
      component: pddIndex //拼多多首页
    },
    {
      path: "/pdd/search",
      name: "pddSearch",
      component: pddSearch //拼多多搜索
    },
    {
      path: "/pdd/share",
      name: "pddShare",
      component: pddShare //拼多多分享链接
    },
    {
      path: "/pdd/linkInto",
      name: "pddLinkInto",
      component: pddLinkInto //拼多多转链
    },
    {
      path: "/mt",
      name: "mtIndex",
      component: mtIndex //美团首页
    },
    {
      path: "/elm",
      name: "elmIndex",
      meta: {
        keepAlive: true
      },
      component: elmIndex //饿了么首页
    },
    {
      path: "/sunning",
      name: "sunningIndex",
      meta: {
        keepAlive: true
      },
      component: sunningIndex //苏宁易购首页
    },
    {
      path: "/sunning/search",
      name: "sunningSearch",
      component: sunningSearch //苏宁易购搜索
    },
    {
      path: "/sunning/detail",
      name: "sunningDetail",
      component: sunningDetail //苏宁易购详情
    },
    {
      path: "/sunning/share",
      name: "sunningShare",
      component: sunningShare //苏宁易购分享链接
    },
    {
      path: "/sunning/linkInto",
      name: "sunningLinkInto",
      component: sunningLinkInto //苏宁易购链接转化
    },
    {
      path: "/wph",
      name: "wphgIndex",
      component: wphgIndex //唯品会首页
    },
    {
      path: "/user",
      name: "user",
      component: user //我的
    },
    {
      path: "/commission",
      name: "commission",
      meta: {
        login: true
      },
      component: commission //佣金
    },
    {
      path: "/help",
      name: "help",
      component: help //新手引导
    },
    {
      path: "/invite",
      name: "invite",
      meta: {
        login: true
      },
      component: invite //我的邀请
    },
    {
      path: "/inviteRecord",
      name: "inviteRecord",
      meta: {
        login: true
      },
      component: inviteRecord //邀请记录
    },
    {
      path: "/order",
      name: "order",
      meta: {
        login: true
      },
      component: order //订单
    },
    {
      path: "/set",
      name: "set",
      meta: {
        login: true
      },
      component: set //设置
    },
    {
      path: "/changeName",
      name: "changeName",
      meta: {
        login: true
      },
      component: changeName //修改昵称
    },
    {
      path: "/withdraw",
      name: "withdraw",
      meta: {
        login: true
      },
      component: withdraw //提现
    },
    {
      path: "/withdraw/record",
      name: "withdrawRecord",
      meta: {
        login: true
      },
      component: withdrawRecord //提现记录
    },
    {
      path: "/alipay",
      name: "alipay",
      meta: {
        login: true
      },
      component: alipay //提现绑定支付宝
    },
    {
      path: "/agreement",
      name: "agreement",
      component: agreement //注册协议
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy //隐私政策
    },
    {
      path: "/editPwd",
      name: "editPwd",
      meta: {
        login: true
      },
      component: editPwd //修改密码
    },
    {
      path: "/login",
      name: "login",
      component: login //登录
    },
    {
      path: "/reg",
      name: "reg",
      component: reg //注册
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.login === true) {
    //  判断登录
    if (store.state.user.id) {
      next();
    } else {
      next({ path: "/login" });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js